import {
  Box,
  Grid,
  Typography,
  Card,
  useTheme,
  Link as MuiLink,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import OrderItemDetailsDrawer from 'components/drawers/order-item-details-drawer/order-item-details-drawer.component';
import { formatCurrency } from 'util/currency';
import { ArrowForward } from '@mui/icons-material';

type OrderInfoProps = {
  orderDetails?: any;
  orderInfoHeader?: React.ReactNode;
};

const OrderInformation = ({
  orderDetails,
  orderInfoHeader,
}: OrderInfoProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const itemDetailsUtilityDrawer = useUtilityDrawer();

  const handleItemDetailsDrawerOpen = () => {
    itemDetailsUtilityDrawer.setDrawerData({
      orderData: orderDetails,
    });
    itemDetailsUtilityDrawer.setOpen(true);
  };

  return (
    <>
      <Box>
        {orderInfoHeader}
        {orderDetails?.orderItems?.map((item, idx) => {
          return (
            <Card
              key={idx}
              sx={{
                borderLeft: `3px solid ${theme.palette.primary.main}`,
                marginBottom: '20px',
              }}
            >
              <Grid container spacing={2} mt={0} pl={2} pr={2}>
                <Grid size={{ xs: 6 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ fontWeight: '700' }}
                  >
                    {item?.itemName}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 3 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{
                      fontWeight: '700',
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    {item?.quantity}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 3 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{
                      fontWeight: '700',
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    {formatCurrency(parseFloat(item.itemTotal.total), 'USD')}
                  </Typography>
                </Grid>
              </Grid>
              {item?.itemDiscounts?.map((discount, idx) => {
                return (
                  <Grid container spacing={2} mt={0} pl={2} pr={2} key={idx}>
                    <Grid size={{ xs: 12 }}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          fontSize: '12px',
                        }}
                      >
                        {t('drawer.orderDetailsDrawer.discount', {
                          discount: discount?.displayAppliedDiscount,
                        })}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}

              {item?.options?.map((option, idx) => {
                return (
                  <Grid container spacing={2} mt={0} pl={2} pr={2} key={idx}>
                    <Grid size={{ xs: 6 }}>
                      <Typography
                        sx={{ fontSize: '12px' }}
                        variant="subtitle2"
                        gutterBottom
                        color="text.secondary"
                      >
                        {option?.itemName}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                      <Typography
                        color="text.secondary"
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          fontSize: '12px',
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        {option?.quantity}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                      <Typography
                        color="text.secondary"
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          fontSize: '12px',
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        {`$${option?.itemTotal?.total / 1000}`}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
              {item?.itemDiscounts?.map((discount, idx) => {
                return (
                  <Grid container spacing={2} mt={0} pl={2} pr={2} key={idx}>
                    <Grid size={{ xs: 12 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        {t('drawer.orderDetailsDrawer.discountApplied', {
                          code: discount?.description,
                        })}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
              <Box
                display={'flex'}
                sx={{ flex: 1 }}
                justifyContent="end"
                pr={2}
                pt={2}
                pb={2}
              >
                <MuiLink
                  sx={{
                    display: 'flex',
                  }}
                  component="button"
                  onClick={() => handleItemDetailsDrawerOpen()}
                  data-testid={'CustomersDataGrid.EditAttribute'}
                >
                  <Typography variant="body2">
                    {t('drawer.orderDetailsDrawer.viewDetails')}
                  </Typography>
                  <ArrowForward sx={{ mr: 1, ml: 1 }} fontSize="small" />
                </MuiLink>
              </Box>
            </Card>
          );
        })}
      </Box>
      <OrderItemDetailsDrawer {...itemDetailsUtilityDrawer} />
    </>
  );
};
export default OrderInformation;
